import {css} from "styled-components";
import {palette} from "styled-theme";
import {
    LEDGER_FADE_IN_TIME,
} from "../containers/AppPage/Bank/Accounts/Reconciliations/Manual/QuickCreateManualRecon/hooks/useCreateTransactionSuccess";
import { theme } from 'antd';

const { defaultAlgorithm, defaultSeed } = theme;
const mapToken = defaultAlgorithm(defaultSeed);

export const CommonStyled = css`
  --brand-color-teal: #1FB6C6;

  .display-none, .none {
    display: none;
  }

  .visibility-hidden {
    visibility: hidden;
  }

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .align-center {
    display: flex;
    align-items: center;
  }

  .flex-space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flex-align-center {
    display: flex;
    align-items: center;
  }

  .center-vertically {
    display: flex;
    align-items: center;
  }

  .center-horizontally {
    display: flex;
    justify-content: center;
  }

  .no-mb {
    margin-bottom: 0 !important;
  }

  .no-pb {
    padding-bottom: 0 !important;
  }

  .hand-cursor {
    cursor: pointer;
  }

  .dragger {
    cursor: ns-resize;
  }

  .bottom-clear {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  /* Global */
  button.link, span.link {
    padding: 0;
    color: #1890ff;
    cursor: pointer;
    background-color: transparent;
    border: transparent;
    outline: none;

    &:hover {
      color: #40a9ff;
    }
  }

  span.shoebox-link {
    color: #1890ff;
    text-decoration: none;
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
    background-color: initial;
    outline: none;
    transition: color .3s;
    text-decoration-skip: objects;
  }


   /* Key Hint (Alt-N) */
  .ant-btn {
    .key-hint {
      margin-left: 8px;
      font-size: 85%;
      color: rgba(0, 0, 0, 45%);
    }

    &.ant-btn-primary {
      .key-hint {
        color: rgba(255, 255, 255, 65%);
      }
    }
  }

  .ant-dropdown-menu-item {
    span.key-hint {
      margin-left: 8px;
      font-size: 75%;
      font-weight: bold;
      opacity: 0.65;
    }
  }

   /* Ellipsis */
  .ellipsis-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ellipsis-div-client {
    display: inline-block;
    max-width: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ellipsis-div-icons {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
  }

  .clamp-multiline-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .clamp-multiline-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .multiline-3-scroll {
    &.minheight-2-rows {
      min-height: calc(${mapToken.lineHeight}rem * 2.2) !important;
    }

    max-height: calc(${mapToken.lineHeight}rem * 3);
    overflow: auto;
    text-overflow: unset;
  }

  .multiline-4-scroll {
    min-height: calc(${mapToken.lineHeight}rem * 4) !important;
    
    &.minheight-3-rows {
      min-height: calc(${mapToken.lineHeight}rem * 3) !important;
    }

    max-height: calc(${mapToken.lineHeight}rem * 4);
    overflow: auto;
    text-overflow: unset;
  }

  .multiline-5-scroll {
    min-height: calc(${mapToken.lineHeight}rem * 3) !important;
    max-height: calc(${mapToken.lineHeight}rem * 5);
    overflow: auto;
    text-overflow: unset;
  }

  .hoverable-icon {
    transition: color 0.3s;

    &.danger {
      color: #ff4d4f;
    }

    &.grey {
      color: #8c8c8c !important;
    }

    &:hover, &:active, &:focus, &:focus-within {
      color: ${palette('primary', 0)} !important;

      &.gray7 {
        color: #8c8c8c !important;
      }

      &.danger {
        color: #ff7875 !important;
      }

      &.grey {
        color: #595959 !important;
      }

      cursor: pointer;

      &.red {
        color: #ff7875 !important;
      }
    }

  }

  .select-children-item {
    height: 22px;
    padding-left: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  .amount-input.bottom-bordered {
    background: inherit;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 20%);
    border-radius: 0;
    box-shadow: none !important;

  }

   /* LTR and RTL */
  .isoLeftRightComponent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .isoCenterComponent {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  
  .deposit-item-amount-input{
    display: flex;
    flex-direction: row-reverse;

    input.ant-input {
      text-align: right;
    }
  }

     /* When payment-amount is undefined */
  .payment-amount-undefined > input.ant-input:not(:focus) {
    color: #bfbfbf
  }

  .payment-amount-undefined-editable-div {
    color: #bfbfbf;
  }

 /* unordered list disc point forms */
  .ul__disc {
    font-size: 12px;
    list-style-position: inside;
    list-style-type: disc;

    .ant-tag {
      margin-right: 0;
      font-size: 11px;
    }

    /* for maybank sync and disconnect modal */
    .li__maybank-tag {
      margin-bottom: 8px;
    }

    &.font-size-14 {
      font-size: 14px;
    }

    &.with-padding-start {
      padding-inline-start: revert;
    }
  }

   /* unordered list empty circle point forms */
  .ul__circle {
    font-size: 12px;
    list-style-position: inside;
    list-style-type: circle;

    &.secondary {
      margin-left: 2em;
    }
  }

  /**
  used in places where there's only one tag in col (eg transaction table Status col).
  for places with multiple tags (eg transaction table Tags), use fading-div.
  */
  .ellipsis-tag {
    max-width: fill-available;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    /* mask-image: linear-gradient(to right, rgba(0,0,0,1) 90%, rgba(0,0,0,0)); */
  }

   /* eg: contact statement email/pdf Drawers when contacts are invalid */
  .warning-box-with-collapse-list {
    padding: 6px;
    margin-right: 0 !important;
    margin-left: 0 !important;
    border-radius: 2px;

    &.warning {
      background-color: #fff1b8;
    }

    &.bordered {
      border: 1px solid #f0f0f0;
    }

    .warning-box-with-collapse-list__header {
      padding: 0 0 6px;
    }

    .ant-collapse > .ant-collapse-item {
      .ant-collapse-header {
        padding: 8px 12px;

         /* padding-left: 40px; */

        .ant-collapse-arrow {
          /* padding: 9px 16px; */
          padding-right: 0;
          padding-bottom: 0;
          padding-left: 0;
        }
      }

      .ant-collapse-content > .ant-collapse-content-box {
        padding: 6px 16px;
      }
    }
  }
  
  .toggle-to-reveal {
    animation: fadeInAnimation 0.3s ease-in;
  }

  @keyframes fadeInAnimation {
    from {
      background-color: #d9f7be;
      opacity: 0
    }

    to {
      background-color: unset;
      opacity: 1;
    }
  }

  .fade-in-from-left {
    animation: fadeFromLeftAnimation ${LEDGER_FADE_IN_TIME}ms cubic-bezier(.48,.90,.48,.90);
  }

  @keyframes fadeFromLeftAnimation {
    from {
      background-color: #d9f7be;
      opacity: 0;
      transform: translateX(-60px);
    }

    to {
      background-color: unset;
      opacity: 1;
      transform: unset;
    }
  }

  
  .tag--help-text {
    margin-right: 0;
    color: #00000050;
  }

  .no-transitions {
    transition: none;
  }

  .full-width {
      width: 100%;
  }

  .full-height {
    min-height: 100%;
  }

  .user-select-none {
    user-select: none;
  }
  
  .small-text {
    font-size: 0.75rem;
  }

  .xsmall-text {
    font-size: 0.625rem;
  }

  /* 
  will add negative margin to offset ant-modal-content padding
  eg: email tracker modal
  */
  .modal-body--no-padding {
    .ant-modal-body {
      margin: 0 -24px;
    }
  }

  /* For mock collapse panel - eg: in PermissionsRow of submodules */
  .panel-title-label {
    position: relative;
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 32px;
    font-size: 14px;
    color: rgba(0,0,0,85%);
  }
  
  .uppercase {
    text-transform: uppercase;
  }
  
  .no-margins {
    margin: 0;
  }

  .inherit-color {
    color: inherit;
  }

  .text-align-center {
    text-align: center;
  }

  .text-align-right {
    text-align: right;
  }
  
  .list-inside-disc {
    list-style: inside disc;
  }

  .display-inline {
    display: inline;
  }

  .max-width-1320 {
    max-width: 1320px;
  }

  .blinking {
    animation: blink-animation 1s linear infinite;
  }

  @keyframes blink-animation {
    0%,100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
  }

  .bolded-gray {
      font-weight: 500;
      color: #8c8c8c
  }

  .monospace {
      font-family: monospace;
  }
`;
